const SCHEDULE_SECTION_KEY = 'schedule'
const MODULE_NAME = 'fulcrum/container/Project/ScheduleSection'

const FETCH_PROJECT_SCHEDULE = MODULE_NAME + '/FETCH_PROJECT_SCHEDULE'
const FETCH_PROJECT_SCHEDULE_START = MODULE_NAME + '/FETCH_PROJECT_SCHEDULE_START'
const FETCH_PROJECT_SCHEDULE_SUCCESS = MODULE_NAME + '/FETCH_PROJECT_SCHEDULE_SUCCESS'
const FETCH_PROJECT_SCHEDULE_ERROR = MODULE_NAME + '/FETCH_PROJECT_SCHEDULE_ERROR'

const POST_PROJECT_SCHEDULE = MODULE_NAME + '/POST_PROJECT_SCHEDULE'
const POST_PROJECT_SCHEDULE_START = MODULE_NAME + '/POST_PROJECT_SCHEDULE_START'
const POST_PROJECT_SCHEDULE_SUCCESS = MODULE_NAME + '/POST_PROJECT_SCHEDULE_SUCCESS'
const POST_PROJECT_SCHEDULE_ERROR = MODULE_NAME + '/POST_PROJECT_SCHEDULE_ERROR'

const UPDATE_PROJECT_SCHEDULE_CHANGE = MODULE_NAME + '/UPDATE_PROJECT_SCHEDULE_CHANGE'
const UPDATE_PROJECT_SCHEDULE_CHANGE_DATE = MODULE_NAME + '/UPDATE_PROJECT_SCHEDULE_CHANGE_DATE'
const UPDATE_PROJECT_SCHEDULE_CHANGE_DATE_INPUT = MODULE_NAME + '/UPDATE_PROJECT_SCHEDULE_CHANGE_DATE_INPUT'
const UPDATE_PROJECT_SCHEDULE_CHANGE_TOGGLE_ENABLED = MODULE_NAME + '/UPDATE_PROJECT_SCHEDULE_CHANGE_TOGGLE_ENABLED'
const RESET_PROJECT_SCHEDULE_CHANGE = MODULE_NAME + '/RESET_PROJECT_SCHEDULE_CHANGE'

const EVT_START = 'evtStart'
const DVT_START = 'dvtStart'
const DVT_SYSTEM_ARRIVAL = 'dvtSystemArrival'
const PVT_START = 'pvtStart'
const PILOT_START = 'pilotStart'
const MP_START = 'mpStart'
const SBIOS_LOCK = 'sbiosLock'
const WHQL_RC = 'whqlRc'
const WHQL_PRODUCTION = 'whqlProduction'
const A_SAMPLE = 'aSample'
const B_SAMPLE = 'bSample'
const C_SAMPLE = 'cSample'
const D_SAMPLE = 'dSample'
const SOP_START = 'sopStart'

const SCHEDULE_LIST = [
    EVT_START,
    DVT_START,
    PVT_START,
    PILOT_START,
    MP_START,
    SBIOS_LOCK,
    WHQL_RC,
    WHQL_PRODUCTION,
    DVT_SYSTEM_ARRIVAL,
    A_SAMPLE,
    B_SAMPLE,
    C_SAMPLE,
    D_SAMPLE,
    SOP_START
]

const NB_DT = [
    EVT_START,
    DVT_START,
    DVT_SYSTEM_ARRIVAL,
    PVT_START,
    PILOT_START,
    MP_START,
    SBIOS_LOCK,
    WHQL_RC,
    WHQL_PRODUCTION,
]

const ENTERPRISE = [
    EVT_START,
    DVT_START,
    PVT_START,
    PILOT_START,
    MP_START,
    SBIOS_LOCK,
    WHQL_RC,
    WHQL_PRODUCTION,
]

const AUTOMOTIVE = [
    A_SAMPLE,
    B_SAMPLE,
    C_SAMPLE,
    D_SAMPLE,
    SOP_START
]

const SCHEDULE_FILTER = [
    {
        segment: 'Notebook',
        schedules: NB_DT
    },
    {
        segment: 'Desktop',
        schedules: NB_DT
    },
    {
        segment: 'Enterprise',
        schedules: ENTERPRISE
    },
    {
        segment: 'Automotive',
        schedules: AUTOMOTIVE
    },
]

const disabledByDefault = [
  SBIOS_LOCK,
  WHQL_RC,
  WHQL_PRODUCTION
]

export {
  SCHEDULE_SECTION_KEY,
  MODULE_NAME,
  FETCH_PROJECT_SCHEDULE,
  FETCH_PROJECT_SCHEDULE_START,
  FETCH_PROJECT_SCHEDULE_SUCCESS,
  FETCH_PROJECT_SCHEDULE_ERROR,
  POST_PROJECT_SCHEDULE,
  POST_PROJECT_SCHEDULE_START,
  POST_PROJECT_SCHEDULE_SUCCESS,
  POST_PROJECT_SCHEDULE_ERROR,
  UPDATE_PROJECT_SCHEDULE_CHANGE,
  UPDATE_PROJECT_SCHEDULE_CHANGE_DATE,
  UPDATE_PROJECT_SCHEDULE_CHANGE_DATE_INPUT,
  UPDATE_PROJECT_SCHEDULE_CHANGE_TOGGLE_ENABLED,
  RESET_PROJECT_SCHEDULE_CHANGE,
  SCHEDULE_LIST,
  SCHEDULE_FILTER,
  disabledByDefault
}